<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Domain</span>
          <span v-else>Create a New Domain</span>
        </h1>
        <span>
          <router-link :to="{ name: 'domains' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div
                :class="['form_row', { has_error: errorFor('domain_name') }]"
              >
                <label class="required">Domain name</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="domain.domain_name"
                  />
                  <v-errors :errors="errorFor('domain_name')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('provider_name') }]"
              >
                <label class="required">Provider name</label>
                <div class="form_input">
                  <input
                    type="text"
                    class="form_global"
                    v-model="domain.provider_name"
                  />
                  <v-errors :errors="errorFor('provider_name')"></v-errors>
                </div>
              </div>

              <div :class="['form_row', { has_error: errorFor('owner_name') }]">
                <label class="required">Owner name</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="domain.owner_name"
                  />
                  <v-errors :errors="errorFor('owner_name')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('expire_date') }]"
              >
                <label class="required">Expire date</label>
                <div class="form_input">
                  <date-picker v-model:input="domain.expire_date"></date-picker>
                  <v-errors :errors="errorFor('expire_date')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row',
                  { has_error: errorFor('domain_renew_date') },
                ]"
              >
                <label class="">Domain renew date</label>
                <div class="form_input">
                  <date-picker
                    v-model:input="domain.domain_renew_date"
                  ></date-picker>
                  <v-errors :errors="errorFor('domain_renew_date')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row',
                  { has_error: errorFor('domain_renew_by') },
                ]"
              >
                <label class="">Domain renew by</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="domain.domain_renew_by"
                  />
                  <v-errors :errors="errorFor('domain_renew_by')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('memo') }]">
                <label>Memo</label>
                <div class="form_inline">
                  <text-editor
                    v-model:text="domain['memo']"
                    :id="'memo'"
                  ></text-editor>
                  <v-errors :errors="errorFor('memo')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6 pl_20">
              <div :class="['form_row', { has_error: errorFor('status') }]">
                <label class="required">Status</label>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="statusActive"
                    v-model="domain.status"
                    value="1"
                  />
                  <label for="statusActive">Active</label>
                </div>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="statusInactive"
                    v-model="domain.status"
                    value="0"
                  />
                  <label for="statusInactive">Inactive</label>
                </div>
                <v-errors :errors="errorFor('status')"></v-errors>
              </div>
              <div :class="['form_row', { has_error: errorFor('auto_renew') }]">
                <label class="required">Auto renew</label>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="autoRenewActive"
                    v-model="domain.auto_renew"
                    value="1"
                  />
                  <label for="autoRenewActive">Active</label>
                </div>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="autoRenewInactive"
                    v-model="domain.auto_renew"
                    value="0"
                  />
                  <label for="autoRenewInactive">Inactive</label>
                </div>
                <v-errors :errors="errorFor('auto_renew')"></v-errors>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('privacy_policy') }]"
              >
                <label class="required">Privacy policy</label>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="privacyPolicyActive"
                    v-model="domain.privacy_policy"
                    value="1"
                  />
                  <label for="privacyPolicyActive">Active</label>
                </div>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="privacyPolicyInactive"
                    v-model="domain.privacy_policy"
                    value="0"
                  />
                  <label for="privacyPolicyInactive">Inactive</label>
                </div>
                <v-errors :errors="errorFor('privacy_policy')"></v-errors>
              </div>
              <div
                :class="[
                  'form_row',
                  { has_error: errorFor('privacy_expire_date') },
                ]"
              >
                <label class="">Privacy expire date</label>
                <div class="form_input">
                  <date-picker
                    v-model:input="domain.privacy_expire_date"
                  ></date-picker>
                  <v-errors
                    :errors="errorFor('privacy_expire_date')"
                  ></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row',
                  { has_error: errorFor('privacy_renew_date') },
                ]"
              >
                <label class="">Privacy renew date</label>
                <div class="form_input">
                  <date-picker
                    v-model:input="domain.privacy_renew_date"
                  ></date-picker>
                  <v-errors :errors="errorFor('privacy_renew_date')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row',
                  { has_error: errorFor('privacy_renew_by') },
                ]"
              >
                <label class="">Privacy renew by</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="domain.privacy_renew_by"
                  />
                  <v-errors :errors="errorFor('privacy_renew_by')"></v-errors>
                </div>
              </div>
              <div class="form_row">
                <label></label>
                <div class="form_inline">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                  <router-link
                    v-if="$route.params.id"
                    :to="{ name: 'domains' }"
                    class="btn btn_transparent has_border_radius ml_10"
                    >Cancel</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TextEditor from '@/components/shared/TextEditor';
import DatePicker from '@/components/shared/DatePicker';
export default {
  name: 'domain-form',
  components: { LoaderMaskComponent, TextEditor, DatePicker },
  data() {
    return {
      lyLoading: false,
      domain: {
        domain_name: '',
        provider_name: '',
        owner_name: '',
        expire_date: '',
        status: 1,
        auto_renew: '0',
        privacy_policy: 1,
        privacy_expire_date: '',
        domain_renew_date: '',
        domain_renew_by: '',
        privacy_renew_date: '',
        privacy_renew_by: '',
        memo: '',
      },
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
  },
  methods: {
    loadData(domainId) {
      this.lyLoading = true;
      this.axios
        .get('/domains/' + domainId)
        .then((response) => {
          this.domain = response.data.data;
          this.domain.status = response.data.data.status ? 1 : '0';
          this.domain.auto_renew = response.data.data.auto_renew ? 1 : '0';
          this.domain.privacy_policy = response.data.data.privacy_policy
            ? 1
            : '0';
        })
        .catch(() => {
          this.showFailMsg('No domain exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.domain).forEach((key) => {
        formData.append(key, this.domain[key] ? this.domain[key] : '');
      });

      this.axios
        .post('/domains', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('Domain Created Successfully!');
          this.$router.push({ name: 'domains' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.domain).forEach((key) => {
        formData.append(key, this.domain[key] ? this.domain[key] : '');
      });

      this.axios
        .post('/domains/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('Domain Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.domain = {
        domain_name: '',
        provider_name: '',
        owner_name: '',
        expire_date: '',
        status: 1,
        auto_renew: 1,
        privacy_policy: 1,
        privacy_expire_date: '',
        domain_renew_date: '',
        domain_renew_by: '',
        privacy_renew_date: '',
        privacy_renew_by: '',
        memo: '',
      };
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
